/**
 * Host Page - Page Shell
 * Imports HostList from features/host
 * Data fetched via React Query hooks
 */

import { HostList } from "@/features/host";

export default function Host() {
  return <HostList />;
}
